import React from 'react';
import PlayersPageWeb from './Players/PlayersPageWeb';
import PlayersPageMobile from './Players/PlayersPageMobile';
import { useIsMobile } from '../../hooks';

// Main Component
const PlayersPage: React.FC = () => {
  const isMobile = useIsMobile();

  return isMobile ? <PlayersPageMobile /> : <PlayersPageWeb />;
};

export default PlayersPage;
